export default __webpack_public_path__ + "static/media/record-phrase-p2.b0060f8d.jpg";